/* eslint-disable no-new */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Vconsole from 'vconsole';
import * as serviceWorker from './serviceWorker';
import { configureStore } from './redux/store';
import 'bootstrap-scss/bootstrap.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-image-lightbox/style.css';
import {
	isMultiColorActive,
	defaultColor,
	isDarkSwitchActive,
	env,
} from './configs/main';
import {
	getCurrentColor,
	setCurrentColor,
	isMobile,
	isInApp,
} from './helpers/Utils';
import './i18n';

const App = React.lazy(() => import(/* webpackChunkName: "app" */ './App'));

if (env !== 'production' && (isInApp() || isMobile())) {
	new Vconsole();
}

const color =
	isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
setCurrentColor(color);

import(`./styles/themes/${color}.scss`).then(() => {
	ReactDOM.render(
		<Provider store={configureStore()}>
			<Suspense fallback={<div className="loading" />}>
				<App />
			</Suspense>
		</Provider>,
		document.getElementById('root')
	);
	/*
	 * If you want your app to work offline and load faster, you can change
	 * unregister() to register() below. Note this comes with some pitfalls.
	 * Learn more about service workers: https://bit.ly/CRA-PWA
	 */
	serviceWorker.unregister();
});
